import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { App } from './App';

import './globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');
rootEl.dataset.version = `${__APP_VERSION__}+${__GIT_COMMIT_HASH__}`;
rootEl.dataset.buildTime = __BUILD_TIME__;

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
